/**
 * @fileoverview Model for submitting a verification to the back end
 *
 * @author Heesun Jun (hjun@yext.com)
 */

export class SubmitVerificationToPublisherRequest {
  /**
   * @param {{
   *  businessId: number,
   *  entityId: number,
   *  externalId: string,
   *  linkedAccountId: number,
   *  groupId: string,
   *  code: string
   * }} params
   */
  constructor(params) {
    /** @type {number} */
    this.businessId = params.businessId;
    /** @type {number} */
    this.entityId = params.entityId;
    /** @type {string} */
    this.externalId = params.externalId;
    /** @type {number} */
    this.linkedAccountId = params.linkedAccountId;
    /** @type {string} */
    this.groupId = params.groupId;
    /** @type {string} */
    this.code = params.code;
  }

  /**
   * @override
   * @return {!Object}
   */
  toJSON() {
    return {
      'businessId': this.businessId,
      'entityId': this.entityId,
      'externalId': this.externalId,
      'linkedAccountId': this.linkedAccountId,
      'groupId': this.groupId,
      'code': this.code,
    };
  }
}
